import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AppShell } from './components/AppShell';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ProjectsPage } from './pages/ProjectsPage';
import { NewBuildPage } from './pages/NewBuildPage';
import { StudioPage } from './pages/StudioPage';
import { PlaystorePage } from './pages/PlaystorePage';
import { SignInPage } from './pages/SignInPage';
import { PlayPage } from './pages/PlayPage';
import { TalkPage } from './pages/TalkPage';
import { LivePage } from './pages/live/LivePage';
import { HostPage } from './pages/live/HostPage';

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>
            <Route path="/sign-in" element={<SignInPage />} />
            {/* public play surface — a client page per the domain rule (pages on codebox.…, APIs
                under /box); lives OUTSIDE AppShell so a bare share link never demands sign-in */}
            <Route path="/play/:slug" element={<PlayPage />} />
            {/* public audience app for presented talks (no account) and its signed-in host console */}
            <Route path="/live/:code" element={<LivePage />} />
            <Route path="/live/:code/host" element={<HostPage />} />
            {/* private full-screen presentations — signed-in only, no studio chrome */}
            <Route
              path="/talks/aic-genai"
              element={<TalkPage slug="aic-genai" title="Introduction to Generative AI" liveCode="aic26" />}
            />
            <Route element={<AppShell />}>
              <Route path="/" element={<Navigate to="/projects" replace />} />
              <Route path="/projects" element={<ProjectsPage />} />
              {/* must precede /projects/:projectId — "new" is a stage, not a project id */}
              <Route path="/projects/new" element={<NewBuildPage />} />
              <Route path="/projects/:projectId" element={<StudioPage />} />
              <Route path="/playstore" element={<PlaystorePage />} />
            </Route>
            <Route path="*" element={<Navigate to="/projects" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}
